<mat-form-field *ngIf="data$ | async as data">
  <mat-label>Filter</mat-label>
  <input matInput type="input" #filter [value]="data.text" (input)="set(filter.value)"/>
</mat-form-field>
